@for (credential of credentials$ | async; track credential) {
  <div class="bv-generator-history-item">
    <div class="bv-generator-history-item__content">
      <bit-color-password
        class="bv-generator-history-item__value"
        [password]="credential.credential"
      />
      <div class="bv-generator-history-item__date">
        {{ credential.generationDate | date: "medium" }}
      </div>
    </div>
    <button
      type="button"
      class="bv-generator-history-item__copy"
      [appCopyClick]="credential.credential"
      [valueLabel]="getGeneratedValueText(credential)"
      [attr.aria-label]="getCopyText(credential)"
      showToast
    >
      <span class="bv-generator-history-item__copy-icon" aria-hidden="true"></span>
      <span class="tw-sr-only">{{ getCopyText(credential) }}</span>
    </button>
  </div>
}
